// Updated vector for GA release

export const ErrorVectorNew = ({
    alt,
    size = "large"
}: {
    alt: string;
    size?: "small" | "large";
}) => {
    const width = size === "small" ? "48" : "160";
    const height = size === "small" ? "48" : "160";

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 157 102"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
        >
            <title>{alt}</title>
            <path
                d="M153.288 54.9818H146.527L143.273 46.7869H124.953C125.241 29.8407 126.969 14.1447 130.071 0H41.1447C40.8829 2.56582 40.6473 5.16436 40.4247 7.776H14.7862L18.0393 15.9775H50.4458L53.6989 24.1789H39.3055C39.3055 24.2836 39.2924 24.3884 39.2858 24.4931L39.1615 24.1789H0L3.25309 32.3804H14.7927L18.0458 40.5818H38.7425C38.6705 44.1164 38.6313 47.6705 38.6313 51.264C38.6313 63.0262 38.9913 74.4153 39.6785 85.4378H24.2444L27.4975 93.6393H17.712L20.9651 101.841H129.849C128.324 94.7585 127.152 87.2902 126.327 79.4618H112.084L108.831 71.2604H120.207L116.954 63.0589L156.548 63.1767L153.295 54.9753L153.288 54.9818Z"
                fill="#DDDEE1"
            />
            <path
                d="M38.7354 40.5821H57.5994L54.3463 32.3806H38.7354V40.5821Z"
                fill="#B7B9BE"
            />
            <path
                d="M41.3081 101.847H60.1721L56.919 93.6394H40.7256L41.3081 101.847Z"
                fill="#B7B9BE"
            />
            <path
                d="M124.475 54.8706H112.51L115.763 63.0786H118.761H124.475V54.8706Z"
                fill="#B7B9BE"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M81.4775 58.2941V25.6584H85.3655V58.2941H81.4775Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M82.5393 64.2431C82.8883 64.1805 83.2213 64.1619 83.5067 64.1619C83.8086 64.1619 84.1078 64.1828 84.4082 64.229L84.4192 64.2307L84.4303 64.2325C86.333 64.5434 87.9168 65.8675 88.3005 67.9834C88.368 68.3419 88.3863 68.686 88.3863 68.9695C88.3863 69.1894 88.3753 69.437 88.3405 69.6992V69.7394L88.3028 69.9497C87.9241 72.0595 86.3442 73.4003 84.4303 73.713L84.4192 73.7148L84.4082 73.7165C84.1078 73.7627 83.8086 73.7837 83.5067 73.7837C83.2191 73.7837 82.8833 73.7648 82.5315 73.701C80.6535 73.3757 79.0775 72.0635 78.6935 69.9572C78.6265 69.6021 78.6074 69.2652 78.6074 68.976C78.6074 68.681 78.6264 68.3405 78.695 67.9808C79.0834 65.9067 80.6266 64.5647 82.5393 64.2431ZM83.4053 68.9635C83.4053 68.9675 83.4052 68.9717 83.4052 68.976C83.4052 68.9781 83.4052 68.9801 83.4053 68.9821C83.4075 68.9823 83.4098 68.9825 83.4124 68.9827C83.4348 68.9844 83.4662 68.9859 83.5067 68.9859C83.5374 68.9859 83.5645 68.985 83.5885 68.9837C83.5885 68.9791 83.5885 68.9744 83.5885 68.9695C83.5885 68.9669 83.5885 68.9644 83.5885 68.9619C83.5645 68.9605 83.5374 68.9597 83.5067 68.9597C83.4661 68.9597 83.4348 68.9611 83.4124 68.9629C83.4098 68.9631 83.4075 68.9633 83.4053 68.9635Z"
                fill="white"
            />
        </svg>
    );
};
